import axios from 'axios';

const $app = (function() {
    var self = {
        load_language_list(vm) {
            vm.$store.state.language_list = [];
            vm.$store.dispatch('loading', {name:'i18n언어', loading:true});
            vm.$c.io.get('/api/system/localization/languages', {}).then(function(response){
                let data = response.data;
                if(data.success) {
                    vm.$store.state.language_list = data.language_list;
                    vm.$store.state.language_id = data.language_id;
                    vm.$store.state.language_list.forEach(x=>{
                        if(x.language_id==data.language_id) {
                            vm.$store.state.datetime_format = x.datetime_format;
                            vm.$store.state.date_format = x.date_format;
                            vm.$store.state.time_format = x.time_format;
                        }
                    });
                }
                vm.$store.dispatch('loading', {name:'i18n언어', loading:false});
            });
        },
        load_currency_list(vm) {
            vm.$store.state.currency_list = [];
            vm.$store.dispatch('loading', {name:'i18n화폐', loading:true});
            vm.$c.io.get('/api/system/localization/currencies', {}).then(function(response){
                let data = response.data;
                if(data.success) {
                    vm.$store.state.currency_list = data.currency_list;
                    vm.$store.state.currency_id = data.currency_id;
                    vm.$store.state.currency_list.forEach(x=>{
                        if(x.currency_id==data.currency_id) {
                            vm.$store.state.currency_value = x.currency_value;
                            vm.$store.state.currency_symbol_left = x.currency_symbol_left;
                            vm.$store.state.currency_symbol_right = x.currency_symbol_right;
                            vm.$store.state.decimal_place = x.decimal_place;
                        }
                    });
                }
                vm.$store.dispatch('loading', {name:'i18n화폐', loading:false});
            });
        },
        load_i18n_data(vm, url_list) {
            vm.$store.state.i18n = {};
            vm.$store.dispatch('loading', {name:'i18n data', loading:true});
            let requests = [];
            url_list.forEach(url=>{
                requests.push(vm.$c.io.get('/api/system/localization/languages/cfg', {url:url}));
            });
            vm.$store.state.i18n = {};
            axios.all(requests).then( axios.spread((...responses)=>{
                responses.forEach(res=>{
                    let data = res.data;
                    for(let key in data.i18n) {
                        vm.$store.state.i18n[key] = data.i18n[key];
                    }
                });
                vm.$store.dispatch('loading', {name:'i18n data', loading:false});
            }));
        },

        load_admin_info(vm) {
            vm.$store.dispatch('loading', {name:'관리자정보', loading:true});
            vm.$store.state.permission = {};
            let url_info = `/api/account/admin/info`;
            axios.all([
                vm.$c.io.get(url_info, {}),
            ]).then( axios.spread((res1)=>{
                let data1 = res1.data;
                if(data1.success) {
                    vm.$store.state.admin_id = data1.admin_prof.admin_id;
                    vm.$store.state.admin.admin_id = data1.admin_prof.admin_id;
                    vm.$store.state.admin.admin_group_id = data1.admin_prof.admin_group_id;
                    vm.$store.state.admin.a_name = data1.admin_prof.a_name;
                    vm.$store.state.admin.admin_name = data1.admin_prof.admin_name;
                }
                function set_permission(value) {
                    for(let key in vm.$store.state.permission) {
                        let group = vm.$store.state.permission[key];
                        group.view = value;
                        group.write = value;
                        for(let page_key in group.page) {
                            group.page[page_key].view = value;
                            group.page[page_key].write = value;
                        }
                    }
                }
                //관리자그룹이면 모든 권한을 설정함.
                if(vm.$store.state.admin.admin_group_id===1) {
                    set_permission(1);
                } else {
                    console.log('권한없음');
                }
                vm.$store.dispatch('loading', {name:'관리자정보', loading:false});
            } ));

        },
        
        
    };
    return self;
})();


export default $app;
